import React from 'react';
import AsyncPrivacy from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <BlankLayout
    key="/business/privacy"
    exact
    path="/business/privacy"
    component={AsyncPrivacy}
  />
);
